const ContentInfo = ({ title, value }) => {
  return (
    <div className="py-2 flex justify-between">
      <span className="caption-12px-regular text-gray-0">{title}:</span>
      <span className="caption-12px-bold text-gray-4 ltr">{value}</span>
    </div>
  );
};
export default ContentInfo;
